import angular from "angular";

angular
    .module('app')
    .component('lessonFormTask', {
        template: require('./lesson-form-task.html'),
        controller: ['$http', '$uibModal', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            lesson: '<',
            task: '<',
            course: '<',
        }
    });

function controller($http, $uibModal, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.enabled = null;
    $ctrl.description = null;
    $ctrl.help = null;

    $ctrl.$onInit = function () {
        $ctrl.enabled = $ctrl.lesson.task ? $ctrl.lesson.task.enabled : null;
        $ctrl.description = $ctrl.lesson.task ? $ctrl.lesson.task.description : null;
        $ctrl.help = $ctrl.lesson.task ? $ctrl.lesson.task.help : null;
    };

    $ctrl.saveTask = function () {

        let params = {
            enabled: $ctrl.enabled,
            description: $ctrl.description,
            help: $ctrl.help,
        };

        $ctrl.loading = true;
        $http.post(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/update-task`, params).then(
            function (response) {
                Notifier.success('Задача успешно обновлена', 2);
                $ctrl.loading = false;
            },

            function (error) {
                Notifier.error('Произошла ошибка', 2);
                $ctrl.loading = false;
            });

    };
    $ctrl.enabledToggle = function (enabled) {
        enabled = !enabled;
        return enabled;
    }
}
